// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vuetify from 'vuetify'
import Vue from 'vue'

Vue.use(Vuetify)

import session from 'sessionstorage'

import localStorage from 'localStorage'

import App from './App'


import router from './router'

import { store } from './storage/vuex-store.js' 
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import { mapActions } from 'vuex'


// var requested_location = this.$route.name
// 	localStorage.setItem('requested_location', requested_location)
// 	console.log(localStorage.getItem('requested_location'))			
			

Vue.config.productionTip = false

window.$ = window.jQuery = require('jquery');
import 'materialize-css/dist/js/materialize.min.js'




/* eslint-disable no-new */
var vm = new Vue({
	store,
	router,
	render: h => h(App),
	components: { App },
}).$mount('#app')

global.vm = vm


// WEBPACK FOOTER //
// ./src/main.js